const MARKETPLACE_PAYOUT_INTERVAL = {
	weekly: 'WEEKLY',
	monthly: 'MONTHLY',
};

export default MARKETPLACE_PAYOUT_INTERVAL;